import { BehaviorSubject } from 'rxjs';
import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MovtoDetails } from 'app/shared/interfaces/movto-details';
import * as moment from 'moment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PageResult } from 'app/shared/interfaces/page-result';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { FatDoctoC } from 'app/shared/interfaces/fat-docto-c';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { FatDoctoCService } from 'app/shared/services/fat-docto-c.service';
import { LancamentoDetailsComponent } from 'app/views/movimentacao/faturamento/lancamento/lancamento-details/lancamento-details.component';

@Component({
  selector: 'app-cadastro-movto-popup',
  templateUrl: './cadastro-movto-popup.component.html',
  styleUrls: ['./cadastro-movto-popup.component.scss']
})
export class CadastroMovtoPopupComponent implements OnInit {

  movtoForm: FormGroup;
  layoutConf: any;
  cadastro: Cadastro;
  pageObjectFatDoctoC$: BehaviorSubject<PageResult<FatDoctoC>> = new BehaviorSubject<PageResult<FatDoctoC>>(null);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  public movtos: FatDoctoC[];
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25];

  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';

  dataFinal = moment(new Date(), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];
  dataInicial = moment(new Date(new Date().setDate(new Date().getDate() - 30)), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];
  detailsMovto: MovtoDetails;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroMovtoPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private loader: AppLoaderService,
    private layout: LayoutService,
    private cadastroService: CadastroService,
    private fatDoctoCService: FatDoctoCService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;
    console.log(`Cadastro: ${this.cadastro.codigo} - ${this.cadastro.razaoSocial}`);

    this.buildMovtoForm();
    this.cadastroService.getMovtoDetails(this.cadastro?.id.toString()).subscribe(movto => { this.detailsMovto = movto; });

    this.pageObjectFatDoctoC$.subscribe(
      page => {
        if (page != null) {
          this.movtos = page.content;
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          if (this.page === 1) {
            this.paginator?.firstPage();
          }
        } else {
          this.movtos = [];
        }
      });
   
    this.reloadPageMovto();  
  }

  buildMovtoForm() {
    this.movtoForm = this.fb.group({
      dataInicial: [this.dataInicial],
      datFinal: [this.dataFinal],
    })

  }

  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.getPageMovto(event.pageIndex + 1, event.pageSize, this.cadastro.id, this.dataInicial, this.dataFinal);
  }

  getPageMovto(page: number, pageSize: number, id: number, dataInicial: string, dataFinal: string) {
    if (id !== undefined) {
      this.cadastroService.getMovto(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString(), dataInicial, dataFinal).subscribe(val => { this.pageObjectFatDoctoC$.next(val) })
    }
  }

  reloadPageMovto() {
    this.page = 1;
    this.getPageMovto(this.page, this.pageSize, this.cadastro.id, this.dataInicial, this.dataFinal);
  }

  openLcto(controle: number) {
    if (!controle) return;
    this.loader.open();
    this.fatDoctoCService.getFatDoctoC(controle).subscribe(
      val => {
        this.loader.close();
        const lctoRef = this.dialog.open(LancamentoDetailsComponent, {
          width: this.layoutConf?.isMobile ? '100vw' : '98%',
          maxWidth: '100vw',
          height: this.layoutConf?.isMobile ? '100dvh' : '90vh',
          maxHeight: '100dvh',
          disableClose: true,
          panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
          data: { payload: val, openAsModal: true },
        });
        lctoRef.backdropClick().subscribe(() => {
          if (this.dialog.openDialogs.length > 0) {
            const cn = confirm('Deseja realmente sair?');
            if (cn) lctoRef.close();
          }
        });
        lctoRef.afterClosed().subscribe(() => {
          this.reloadPageMovto();
        });
      },
      err => {
        this.loader.close();
        this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${err}`, error: true });
      }
    );
  }

  submit() {
   
  }

  close() { 
    this.dialogRef.close();
  }
  

}
